export default __webpack_public_path__ + "static/media/process-link.6dd2e817.svg";